export default "__VITE_ASSET__DJzMUm1f__"